import EnableAutomaticInvoicingError from './EnableAutomaticInvoicingError';
class InvestorFiscalZipCodeDoesNotMatchWithTaxSystem extends EnableAutomaticInvoicingError {
    constructor(options) {
        super('Investor Zip Code Does Not Match With The Tax System', options);
    }
}
export default InvestorFiscalZipCodeDoesNotMatchWithTaxSystem;
